import {Injectable, Injector} from '@angular/core';
import {HttpClient, HttpHeaders, } from '@angular/common/http';
import {AccessTokenService} from './user/access-token.service';
import {environment} from '../environments/environment';
import {map} from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectorsService {
  authedOptions: any;
  authedMultipartOptions: any;
  servicesOptions: any;
  accessOptions: any;
  devAccessOptions: any;
  campaignOptions: any;
  httpOptions: any;
  samplesOptions: any;
  headersOptions: any;
  constructor(private _http: HttpClient,
              private injector: Injector) {
  }

  getAuth() {
    const auth = this.injector.get(AccessTokenService);
    return 'Bearer ' + auth.token;
  }

  getHttp() {
    const auth = this.injector.get(AccessTokenService);
    const jwt = auth.token;

    this.authedOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.getAuth(),
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };
    this.authedMultipartOptions = {
      headers: new HttpHeaders({
        'Authorization': this.getAuth(),
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };
    this.samplesOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'pkey': environment.samplesPkey,
        'apikey': environment.samplesAPIKey,
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };
    this.servicesOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'pkey': environment.servicesPkey,
        'apikey': environment.servicesAPIKey,
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };
    this.campaignOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'pkey': environment.campaignPkey,
        'apikey': environment.campaignAPIKey,
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'pkey': localStorage.getItem('partnerKey'),
        'Access-Control-Allow-Origin': '*',
        'observe': 'response'
      })
    };
    this.headersOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'pkey': '3fd7244d02a830763fcddf5c572a5b54', // Replace with your actual partner key
      })
    };
  }

  getRawDataKeyTypes() {
    this.getHttp();
    return this._http.get(environment.coreHost + '/v1/connectors', this.authedOptions)
        .pipe(map(response => response));
  }
  getApiExecutorsForPartnerAccount() {
    this.getHttp();
    // return this._http.get(environment.apihost + '/v1/api/b2b/b2b/producer/slack/executors', this.samplesOptions)
    //     .pipe(map(res => res));
    // break;
    // default:
    return this._http.get(environment.apihost + '/v1/api/b2b/b2b/producer/executors?producer=', this.httpOptions)
        .pipe(map(res => res));
    // break;

  }
  getExecutors(params): Observable<any> {
    const partner = 'b2b'; // Replace with the correct partner value
    const account = 'b2b'; // Replace with the correct account value
    // const params = 'slack';
    const apiUrl = environment.apihost + `/v1/api/${partner}/${account}/producer/executors?producer=${params}`;
    return this._http.get(apiUrl, this.headersOptions).pipe(
        map((res) => res)
    );
  }

  getMyProviderExecutors(partner, account, params) {
    this.getHttp();
    return this._http.get(environment.apihost + '/v1/api/' + partner + '/' + account + '/producer/executors?producer=' + params, this.httpOptions)
        .pipe(map(res => res));
  }
  getData(partner, account, version, entity, queryParams) {
    let apiURL = environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity;
    if (queryParams) {
      apiURL = apiURL + '?' + queryParams;
    }
    this.getHttp();
    switch (partner) {
      case 'services' :
        return this._http.get(apiURL, this.servicesOptions)
            .pipe(map(res => res));
      case 'access' :
        return this._http.get(apiURL, this.accessOptions)
            .pipe(map(res => res));
      case 'dev-access':
        return this._http.get(apiURL, this.devAccessOptions)
            .pipe(map(res => res));
      case 'campaign' :
        return this._http.get(apiURL, this.campaignOptions)
            .pipe(map(res => res));
      default :
        return this._http.get(apiURL, this.httpOptions)
            .pipe(map(res => res));
    }
  }
}
